import { render, staticRenderFns } from "./DocumentHeader.vue?vue&type=template&id=f864914e&scoped=true"
import script from "./DocumentHeader.vue?vue&type=script&lang=js"
export * from "./DocumentHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentHeader.vue?vue&type=style&index=0&id=f864914e&prod&lang=scss"
import style1 from "./DocumentHeader.vue?vue&type=style&index=1&id=f864914e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f864914e",
  null
  
)

export default component.exports